// extracted by mini-css-extract-plugin
export default {"pill":"style_pill__cHIkh","weak":"style_weak__G+c4Q","average":"style_average__kY1i0","strong":"style_strong__2H+iH"};